/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.template.geoarea.popup',[]).controller('GeographicalAreaPopupController', function($uibModalInstance, origin, geoAreaMemberships){
    var geoAreaPopupCtrl = this;
    geoAreaPopupCtrl.origin = origin;
    geoAreaPopupCtrl.geoAreaMemberships = geoAreaMemberships;
    geoAreaPopupCtrl.close = function (){
         $uibModalInstance.dismiss('Close');
    };
});



// WEBPACK FOOTER //
// ./app/common/popup/geo-area/geo-area-popup.js